module.exports = __webpack_public_path__ + "p2_img1.jpg?45473481a69d98c0e7687640792c3d03";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p2/p2_img1.jpg
// module id = 114
// module chunks = 0